import { createBlock } from 'factories/block';
import { InteractionProps } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';
import { createEditableBtn } from './editableBtn';
import { createFeedbackBlock } from './feedback';

export type ImageInteractionProps = InteractionProps & {};

const contentForColumn = props => (i: number) => {
  return [
    () =>
      createBlock('TextEntryVariable', [
        createEditableBtn({
          label: 'Submit',
        }),
      ]),
    () =>
      createBlock('ColumnImageAndText', [
        createMediaBlock({ child: 1 }),
        createBlock('Text'),
      ]),
  ][i];
};

export const createTextEntryVariableInteractionBlock = (props: any) => {
  // will fix this up later with the ' prop 'er definitions etc

  const { lockDown = 0, style } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(0), 0, false),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        lockDown,
      },
      meta: {
        subType: 'TextEntryVariable',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const interactionConfig = {};
